import css from 'styled-jsx/css';
import { colors, typography } from '../../../../../config/styles';

export const AccordionItemStyles = css`
  .accordion__item {
    border-radius: 12px;
    background-color: ${colors.gray.shade12};
    overflow: hidden;
    transition: all 0.3s ease;
    margin-bottom: 4px;

    @media (max-width: 767px) {
      border-radius: 0;
      background-color: ${colors.white.shade1};
      border-bottom: 1px solid ${colors.gray.shade50};

      &:last-child {
        border-bottom: none;
      }
    }

    &.accordion__item--open {
      background-color: ${colors.white.shade1};
      border: 1px solid ${colors.gray.shade6};

      @media (max-width: 767px) {
        border: none;
      }

      .accordion__title {
        @media (min-width: 768px) {
          font-weight: 400;
        }
      }
    }

    &.accordion__item--product {
      border: none;
      border-bottom: 1px solid ${colors.gray.shade5};
      border-radius: 0;
      background-color: transparent;
      margin-bottom: 0;

      &:last-child {
        border-bottom: none;
      }
    }

    &.accordion__item--filter {
      border: 1px solid ${colors.gray.shade6};
      border-radius: 8px;
      background-color: ${colors.gray.shade1};
    }
  }

  .accordion__header {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    padding: 12px 16px;
    background: none;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s ease;

    @media (max-width: 767px) {
      min-height: 56px;
      padding: 16px;
      -webkit-tap-highlight-color: transparent;
      touch-action: manipulation;
    }

    .accordion__item--product & {
      padding: 16px 0;
      border-bottom: none;

      @media (min-width: 768px) {
        padding: 24px 0;
      }

      &:hover {
        background-color: transparent;
      }
    }

    .accordion__item--filter & {
      padding: 10px 12px;
      background-color: ${colors.gray.shade3};
      border-radius: 8px 8px 0 0;

      @media (min-width: 768px) {
        padding: 14px 16px;
      }

      &:hover {
        background-color: ${colors.gray.shade4};
      }
    }
  }

  .accordion__title {
    font-weight: 400;
    font-style: Bold;
    leading-trim: NONE;
    letter-spacing: 0%;
    font-size: 14px;
    color: ${colors.black.shade10};
    line-height: 1.4;

    @media (min-width: 768px) {
      font-weight: 700; /* Bold when closed in desktop */
    }

    @media (max-width: 767px) {
      font-weight: 600;
      font-size: ${typography.base};
      flex: 1;
      margin-right: 12px;
    }

    .accordion__item--product & {
      font-size: ${typography.base};
      font-weight: 600;

      @media (min-width: 768px) {
        font-size: ${typography.lg};
      }
    }

    .accordion__item--filter & {
      font-size: ${typography.sm1};
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }

  .accordion__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;
    color: ${colors.gray.shade15};

    @media (max-width: 1023px) {
      min-width: 24px;
      min-height: 24px;
      flex-shrink: 0;
    }

    .accordion__item--filter & {
      color: ${colors.gray.shade19};
    }
  }

  .accordion__content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease;
    background-color: ${colors.white.shade1};

    &.accordion__content--open {
      max-height: fit-content;
    }

    .accordion__item--product & {
      background-color: transparent;
    }

    .accordion__item--filter & {
      background-color: ${colors.gray.shade1};
    }
  }

  .accordion__content-inner {
    padding: 0 16px;
    position: relative;

    @media (max-width: 767px) {
      padding: 0 16px;
    }

    .accordion__content--open & {
      padding: 16px;

      @media (max-width: 767px) {
        padding: 16px;
      }
    }

    &.accordion__content-inner--truncated {
      position: relative;
    }

    .accordion__item--product & {
      padding: 0 0 16px;

      @media (min-width: 768px) {
        padding: 0 0 20px;
      }

      .accordion__content--open & {
        padding: 16px 0 20px;

        @media (min-width: 768px) {
          padding: 16px 0 20px;
        }
      }
    }

    .accordion__item--filter & {
      padding: 0 12px 12px;

      @media (min-width: 768px) {
        padding: 0 16px 12px;
      }

      .accordion__content--open & {
        padding: 12px;

        @media (min-width: 768px) {
          padding: 12px 16px;
        }
      }
    }
  }

  .accordion__content-gradient {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: linear-gradient(to top, ${colors.white.shade1} 0%, rgba(255, 255, 255, 0.8) 50%, transparent 100%);
    pointer-events: none;
    z-index: 1;

    .accordion__item--product & {
      background: linear-gradient(to top, transparent 0%, rgba(255, 255, 255, 0.8) 50%, transparent 100%);
    }

    .accordion__item--filter & {
      background: linear-gradient(to top, ${colors.gray.shade1} 0%, rgba(248, 249, 250, 0.8) 50%, transparent 100%);
    }
  }

  .accordion__show-more-btn {
    width: 100%;
    padding: 8px 12px;
    background: none;
    border: none;
    color: ${colors.blue.shade10};
    font-size: ${typography.sm1};
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    transition: color 0.2s ease;
    position: relative;
    z-index: 2;
    text-transform: capitalize;

    @media (max-width: 767px) {
      padding: 12px 16px;
      font-size: ${typography.base};
      min-height: 44px;
      -webkit-tap-highlight-color: transparent;
      touch-action: manipulation;
    }

    &:hover {
      color: ${colors.blue.shade12};
      text-decoration: underline;
    }

    &:focus {
      outline: 2px solid ${colors.blue.shade8};
      outline-offset: 2px;
    }

    .accordion__item--product & {
      padding: 8px 0;

      @media (min-width: 768px) {
        padding: 12px 0;
      }
    }

    .accordion__item--filter & {
      background-color: ${colors.gray.shade1};
      border-top: 1px solid ${colors.gray.shade4};
    }
  }
`;
